import { ErrorBoundary } from './ErrorBoundary';

export type { TypeErrorBoundaryProps } from './types';
export default ErrorBoundary;
